import React from "react";
import { CSSProp, styled } from "styled-components";

interface Props {
    text: string;
    width?: string;
    height?: string;
    addStyles?: CSSProp;
    onClick: (t: any) => void;
    isDisabled?: boolean;
    inputRef?: any;
}

const MgButton: React.FC<Props> = ({
    text,
    width = "332px",
    height = "46px",
    onClick,
    isDisabled = false,
    addStyles,
    inputRef,
}) => {
    return (
        <BtnStyle $width={width} $height={height} ref={inputRef} $addStyle={addStyles} onClick={onClick} disabled={isDisabled}>
            {text}
        </BtnStyle>
    );
};

export default MgButton;

const BtnStyle = styled.button<{ $width: string; $height: string; $addStyle: CSSProp }>`
    padding: 14px;
    gap: 10px;
    width: ${(props) => props.$width};
    height: ${(props) => props.$height};
    background: #ffffff;
    border-radius: 14px;
    border: 1px solid #2275ee;
    color: #2275ee;
    font-size: 16px;
    font-weight: 400;
    cursor: pointer;

    ${(props) => props.$addStyle}
`;
